import {Component, Input, OnInit} from '@angular/core';
import {BlacklistRemarkModel} from '../../../../shared/dto/blacklist-remark.model';

@Component({
  selector: 'app-reveresed-remark-history',
  templateUrl: './reveresed-remark-history.component.html',
  styleUrls: ['./reveresed-remark-history.component.scss']
})
export class ReveresedRemarkHistoryComponent implements OnInit {
  @Input() data: BlacklistRemarkModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  public remarkHistory: BlacklistRemarkModel[] = [];
  constructor() { }

  ngOnInit() {

  }
}
